// extracted by mini-css-extract-plugin
module.exports = {"content":"InitialTreatment_content__ciAUq","already":"InitialTreatment_already__GxVcu"};